import { readRuntimeDiagnosticMode } from './app/runtime-diagnostics'

const container = document.getElementById('root')!

if (readRuntimeDiagnosticMode() === 'bare') {
  document.documentElement.style.colorScheme = 'dark'
  document.body.style.margin = '0'
  document.body.style.background = '#08090b'
  document.body.style.color = '#f4f4f5'
  document.body.style.font = '16px/1.5 system-ui, sans-serif'
  container.innerHTML = `
    <main style="box-sizing:border-box;min-height:100vh;display:grid;place-items:center;padding:32px">
      <section style="width:min(560px,100%);padding:32px;border:1px solid #2b2f36;border-radius:24px;background:#111318">
        <small style="color:#a78bfa;letter-spacing:.16em">SPEC-044 / BARE</small>
        <h1 style="margin:16px 0 8px;font-size:28px">最小页面诊断正在运行</h1>
        <p style="margin:0;color:#9ca3af">未加载 React、React Flow、节点、项目数据或助手。请保持此页面 60 秒。</p>
      </section>
    </main>`
} else {
  void import('./bootstrap-app').then(({ mountApp }) => mountApp(container))
}
